/**
 * Created by rickborst on 22/08/2017.
 */

class Row {

    /**
     * Constructs the object.
     *
     * @param {Object} options - Options object.
     */
    constructor (options = {}) {

        this.channel = options.channel || null;
        this.assets = options.assets || [];
    }
}

export default Row;


// WEBPACK FOOTER //
// ./src/js/models/epgsection/row.js